<div class="help-doc-container">
  <div >
    <span class="help-title">Help Documents</span>
    <ul>
      <li>
        <a href="/assets/documents/LMS-WorkStation-UserGuide-V2.pdf" target="_blank" rel="noopener noreferrer">LMS-WorkStation-UserGuide-V2.pdf</a>
      </li>
      <li>
        <a href="/assets/documents/Locomotive-Icon-One-Pager.pdf" target="_blank" rel="noopener noreferrer">Locomotive-Icon-One-Pager.pdf</a>
      </li>
    </ul>
    </div>
  </div>